// extracted by mini-css-extract-plugin
module.exports = {"small":"Avatar_small__HkubT","medium":"Avatar_medium__2jvtt","large":"Avatar_large__32fLL","avatar":"Avatar_avatar__2AyzH"};